export default __webpack_public_path__ + "static/logo-7b2c43f36c515cdc01daef849a920302.svg";